export const MAP_DEFAULT_ZOOM = 17;

export const MAP_TILE_URL =
  "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}";

export const MAP_TILE_ATTRIBUTION = "";

export const MARKER_ICON_SIZE = [28, 40];

export const MARKER_ICON_ANCHOR = [14, 40];
